// import React from "react";
// import { Navigation, Pagination, A11y } from "swiper/modules";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import AnchorLink from "react-anchor-link-smooth-scroll";

// import arrow from "../../images/down-arrow.svg";

// const Slide1 =
//   "https://res.cloudinary.com/dexvxngzg/image/upload/v1764738937/facade_lot_121_option_1_erzo6m.jpg";

// const Slide2 =
//   "https://res.cloudinary.com/dexvxngzg/image/upload/v1764738934/facade_lot_121_option_2_p21ecb.jpg";

// const Slide6 =
//   "https://res.cloudinary.com/dexvxngzg/image/upload/v1764835603/hero-text.843765fe67bac60251f4_fsqswd.jpg";

// const Hero = () => {
//   return (
//     <section className="wpo-hero-slider">
//       <Swiper
//         className="swiper-container"
//         modules={[Navigation, A11y, Pagination]}
//         spaceBetween={0}
//         slidesPerView={1}
//         loop={true}
//         speed={1800}
//         parallax={true}
//         navigation={false}
//         pagination={{
//           clickable: true,
//           el: ".swiper-pagination",
//           type: "fraction",
//           renderFraction: (currentClass, totalClass) =>
//             `<span class="${currentClass}"></span> / <span class="${totalClass}"></span>`,
//         }}
//       >

//         {/* SLIDE 1 */}
//         <SwiperSlide>
//           <div
//             className="slide-inner slide-bg-image"
//             style={{
//               backgroundImage: `url(${Slide1})`,
//               position: "relative",
//             }}
//           >
//             {/* 🔥 LIGHT BLACK OVERLAY */}
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 background:
//                   "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.35))",
//                 zIndex: 1,
//               }}
//             />

//             <div className="container" style={{ position: "relative", zIndex: 2 }}>
//               <div className="slide-content">
//                 <div className="slide-sub-title">
//                   <h2 style={{ fontWeight: "900", color: "#fff" }}>
//                     Building Australia’s Finest Homes —
//                     <span>
//                       <img src={Slide6} alt="QHB Australia Premium Homes" />
//                     </span>
//                     Crafted with Innovation & Strength
//                   </h2>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </SwiperSlide>

//         {/* SLIDE 2 */}
//         <SwiperSlide>
//           <div
//             className="slide-inner slide-bg-image"
//             style={{
//               backgroundImage: `url(${Slide2})`,
//               position: "relative",
//             }}
//           >
//             {/* 🔥 LIGHT BLACK OVERLAY */}
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 background:
//                   "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.35))",
//                 zIndex: 1,
//               }}
//             />

//             <div className="container" style={{ position: "relative", zIndex: 2 }}>
//               <div className="slide-content">
//                 <div className="slide-sub-title">
//                   <h2 style={{ fontWeight: "900", color: "#fff" }}>
//                     Your Trusted Australian Home Builder —
//                     <span>
//                       <img src={Slide6} alt="QHB Australia Home Builders" />
//                     </span>
//                     Designed with Precision, Built for Life
//                   </h2>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </SwiperSlide>

//         <div className="swiper-pagination"></div>
//       </Swiper>

//       {/* SCROLL BUTTON */}
//       <AnchorLink href="#about" className="scroll-btn">
//         <span>Explore QHB Excellence</span>
//         <div className="scroll-befor">
//           <img src={arrow} alt="Scroll Down" />
//         </div>
//       </AnchorLink>
//     </section>
//   );
// };

// export default Hero;




import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y } from "swiper/modules";
import "swiper/css";

/* ---------------- IMAGES ---------------- */
const Slide1 =
  "https://res.cloudinary.com/dtivafy25/image/upload/v1766453264/Untitled_design_wf026q.webp";

const Slide6 =
  "https://res.cloudinary.com/dexvxngzg/image/upload/v1764835603/hero-text.843765fe67bac60251f4_fsqswd.jpg";

/* ---------------- HERO ---------------- */
const Hero = () => {
  return (
    <section className="wpo-hero-slider">
      <Swiper
        className="swiper-container"
        modules={[A11y]}
        slidesPerView={1}
        loop={false}
        speed={1200}

        /* ❌ REMOVED */
        // navigation={true}
        // pagination={{ ... }}
      >
        {/* ================= SINGLE SLIDE ================= */}
        <SwiperSlide>
          <div
            className="slide-inner slide-bg-image"
            style={{
              backgroundImage: `url(${Slide1})`,
              position: "relative",
            }}
          >
            {/* 🔥 LIGHT BLACK OVERLAY */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.35))",
                zIndex: 1,
              }}
            />

            <div
              className="container"
              style={{ position: "relative", zIndex: 2 }}
            >
              <div className="slide-content">
                <div className="slide-sub-title">
                  <h2 style={{ fontWeight: "900", color: "#fff" }}>
                    Building Australia’s Finest Homes —
                    <span>
                      <img
                        src={Slide6}
                        alt="QHB Australia Premium Homes"
                      />
                    </span>
                    Crafted with Innovation & Strength
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>

        {/* ❌ REMOVED PAGINATION (1 / 2) */}
        {/* <div className="swiper-pagination"></div> */}
      </Swiper>

      {/* ❌ REMOVED SCROLL ARROW */}
      {/*
      <AnchorLink href="#about" className="scroll-btn">
        <span>Explore QHB Excellence</span>
        <div className="scroll-befor">
          <img src={arrow} alt="Scroll Down" />
        </div>
      </AnchorLink>
      */}
    </section>
  );
};

export default Hero;
